<div class="row">

  <div class="col-md-10">
    <div mat-dialog-content  >

      <mat-form-field  class="search-full-width">

        <input cdkFocusInitial matInput [(ngModel)]="data.searchText"   placeholder="Digite as palavras para busca" (keydown.enter)="closeDialog()">
        <!--  -->

      </mat-form-field>
    </div>
  </div>
  <div class="col-md-2">
    <div mat-dialog-actions>
      <button mat-raised-button  color="primary" [mat-dialog-close]="data.searchText" >
         Buscar agora
      </button>

    </div>
  </div>

</div>